import valid from 'card-validator'

export default function validateCreditCard(value) {
  const numberValidation = valid.number(value)
  return numberValidation.isPotentiallyValid ? undefined : 'Cartão de crédito inválido.'
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/creditCardValidate.js